/* eslint-disable import/prefer-default-export */
import { useQuery, OperationVariables } from '@apollo/client';

export const useQueryFix = <
  Query = any,
  QueryVariables extends OperationVariables = OperationVariables,
>(
  query: any,
  options?: any,
) => {
  const { data, ...queryResult } = useQuery<Query, QueryVariables>(query, options);

  let newData: Query | undefined = data as Query | undefined;
  if (queryResult.error) {
    if (data === null) newData = undefined;
  } else if (!data) newData = queryResult.previousData as Query;

  return {
    data: newData,
    ...queryResult,
  };
};
